module.exports = __webpack_public_path__ + "static/img/plc.4c572f1b.png";